import callApi from "./callApi";

const identifyUser = (userId: string) => {
  callApi((api) => api.setUserId(userId));
};

export default identifyUser;
